import React, { useEffect, useState } from "react";
import FirstPage from "../../image/FirstPage.svg";
import SecondPage from "../../image/SecondPage.svg";
import ThirdPage from "../../image/ThirdPage.svg";
import FourthPage from "../../image/FourthPage.svg";
import logo from "../../image/logo.svg";
import LoginButton from "../../image/LoginButton.svg";
import { Link, NavLink, Outlet } from "react-router-dom";
import "./Sidebar.css";
import { maxWidth, minWidth, width } from "@mui/system";

const Sidebar = () => {
  const [color, setColor] = useState();

  const handler = (e) => {
    e.target.style.border = "2px solid red";
  };
  const NavItems = [
    {
      path: "/dashboard",
      icon: <img src={FirstPage} alt="sidebar Firstpage" className="Icons1" />,
    },
    {
      path: "/forms",
      icon: (
        <img src={SecondPage} alt="sidebar Secondpage" className="Icons2" />
      ),
    },
    {
      path: "/applications",
      icon: <img src={ThirdPage} alt="sidebar Thirdpage" className="Icons3" />,
    },
    {
      path: "/reports",
      icon: (
        <img src={FourthPage} alt="Sidebar Fourthpage" className="Icons4" />
      ),
    },
  ];
  const [isDesktop, setDesktop] = useState(window.innerWidth > 810);

  const updateMedia = () => {
    setDesktop(window.innerWidth > 800);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  function myFunction() {
    var x = document.getElementById("Togglenavbar");
    if (x.style.display === "block") {
      x.style.display = "none";
    } else {
      x.style.display = "block";
    }
  }

  return (
    <div className="container-fluid">
      <div className="Container ">
        {isDesktop ? (
          <div className="sidebar">
            <div className="top-section">
              <Link to="/dashboard">
                <img src={logo} className="logo" alt="Logo" />
              </Link>
              <div className="MainpageIcons">
                {NavItems.map((item, index) => (
                  <NavLink
                    to={item.path}
                    key={index}
                    className="link"
                    activeClassName="active"
                  >
                    <div className="icon">{item.icon}</div>
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* Mobile view hamburger */}
            <nav className="ToggleResponsiveness navbar nav">
              <Link to="/dashboard">
                <img src={logo} className="logo" alt="Logo" />
              </Link>
              <div className="ToggleMenu">
                <div for="check" className="togglemenu" onClick={myFunction}>
                  <i class="fas fa-bars" id="sidebar_btn"></i>
                </div>

                <div id="Togglenavbar">
                  <Link to="/dashboard">
                    <li>Dashboard</li>
                  </Link>
                  <Link to="/forms">
                    <li>Forms</li>
                  </Link>
                  <Link to="/applications">
                    <li>Applications</li>
                  </Link>
                  <Link to="/reports">
                    <li>Reports</li>
                  </Link>
                </div>
              </div>
            </nav>
          </>
        )}
        <div className="container col-md-11 col-xs-11 col-lg-11 col-sl-11">
          <main style={{ height: "100%", width: "103%" }}>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};
export default Sidebar;
